import KindOfWaste from './containers/KindOfWaste';

export default KindOfWaste;
